// TSS vite/03 §"Query keys convention". Plantillas de notificación.

export const templateKeys = {
    all:    ['notification-templates'],
    list:   (filters) => ['notification-templates', 'list', filters],
    detail: (code)    => ['notification-templates', 'detail', code],
};
